export default __webpack_public_path__ + "static/media/Functies.10e0f4a5.svg";